'use strict';

angular.module('mobile-apps')
	.factory('GlossaryMain', [
		'$rootScope',
		'$stateParams',
		'$window',
		'GlossaryEntries',
		'EventTracker',
		'MobileApps',
		'CacheDataLoad',
		function(
			$rootScope,
			$stateParams,
			$window,
			GlossaryEntries,
			EventTracker,
			MobileApps,
			CacheDataLoad
		) {

			var factory = {};

			factory.entries = {};


			/**
			 * Loads the glossary entries of the given appId
			 */
			factory.loadGlossary = function (appId, forceRefresh, cb) {
				var me = this;

				var getModelData = function(appId, callback) {
					GlossaryEntries.get(
						{
							mobileAppId: appId
						}, function(data) {
							callback(null, data);
						}, function(err) {
							callback(err);
						}
					);
				};

				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'glossaryEntries', appId, forceRefresh,
					function(err, glossaryEntries) {
						if (err) {
							me.entries = {};
							return cb(err);
						}

						me.entries = {};
						if (glossaryEntries) {
							glossaryEntries.forEach(function(entry) {
								me.entries[entry._id] = entry;
							});
						}

						cb(null, me.entries);
					}
				);
			};


			/**
			 * Creates a glossary entries
			 */
			factory.create = function(mobileAppId, newEntries, callback) {
				var me = this;

				GlossaryEntries.create({mobileAppId: mobileAppId, entries: newEntries},
					function(entries) {
						// Add the new entries to the internal data
						entries.forEach(function(entry) {
							me.entries[entry._id] = entry;
						});

						callback(null, entries);
					}, function(err) {
						callback(err);
					}
				);
			};


			/**
			 * Updates glossary entries
       		 */
			factory.update = function(mobileAppId, entries, callback) {
				var me = this;

				GlossaryEntries.update(
					{
						mobileAppId: mobileAppId,
						entries: entries
					}, function(entries) {

						// Update the entries in the internal data
						entries.forEach(function(entry) {
							if (me.entries[entry._id]) {
								for (var language in entry.translations) {
									me.entries[entry._id].translations[language] = entry.translations[language];
								}
								me.entries[entry._id].description = entry.description;
								me.entries[entry._id].updatedAt = entry.updatedAt;
							}
						});

						callback(null, entries);
					}, function(err) {
						callback(err);
					}
				);
			};


			/**
			 * Creates a language entry in an existing glossary entry
	         */
			factory.createLanguageEntry = function(mobileAppId, entryId, language, callback) {
				var me = this;

				if (language === undefined || !angular.isString(language)) {
					return callback('No language to add');
				}

				var entry = me.entries[entryId];

				if (!entry) {
					return callback('Entry not found');
				}


				if (entry.translations.hasOwnProperty(language)) {
					return callback('Language already exists');
				}

				var translationsCopy = angular.copy(entry.translations);
				entry.translations[language] = '';

				var entries = [
					{
						_id: entry._id,
						translations: entry.translations
					}
				];

				me.update(mobileAppId, entries,
					function(err, entries) {

						if (err) {
							entry.translations = translationsCopy;
							return callback(err);
						}

						callback(null, entries);
					}
				);
			};


			/**
			 * Updates translation in a glossary entry
			 */
			factory.changeTranslation = function(mobileAppId, entryId, language, data, callback) {
				var me = this;

				var entry = me.entries[entryId];

				if (!entry) {
					return callback('Entry not found');
				}

				entry.translations[language] = data;

				var entries = [
					{
						_id: entry._id,
						translations: entry.translations
					}
				];

				me.update(mobileAppId, entries,
					function(err, entries) {
						if (err) {
							return callback(err);
						}

						callback(null, entries);
					}
				);

			};


			/**
			 * Updates description on a glossary entry
			 */
			factory.changeDescription = function(mobileAppId, entryId, description, callback) {
				var me = this;

				var entry = me.entries[entryId];

				if (!entry) {
					return callback('Entry not found');
				}

				var entries = [
					{
						_id: entry._id,
						description: description
					}
				];

				me.update(mobileAppId, entries,
					function(err, entries) {
						if (err) {
							return callback(err);
						}

						callback(null, entries);
					}
				);

			};


			/**
			 * Deletes a translation in a glossary entry
			 */
			factory.deleteTranslation = function(mobileAppId, entryId, language, callback) {
				var me = this;

				var entry = me.entries[entryId];

				if (!entry) {
					return callback('Entry not found');
				}

				if (!entry.translations.hasOwnProperty(language)) {
					return callback('The language does not existEntry');
				}

				delete entry.translations[language];

				GlossaryEntries.update(
					{
						mobileAppId: mobileAppId,
						entries: [
							{
								_id: entry._id,
								translations: entry.translations
							}
						]
					},
					function(entries) {
						callback(null, entries);
					}, function(err) {
						callback(err);
					}
				);
			};


			/**
			 * Deletes a glossary entries
			 */
			factory.delete = function(mobileAppId, entryIds, callback) {
				var me = this;

				GlossaryEntries.remove(
					{
						mobileAppId: mobileAppId,
						entryIds: entryIds
					},
					function(entryIds) {
						// Delete the entries in internal data
						entryIds.forEach(function(entryId) {
							if (me.entries.hasOwnProperty(entryId)) {
								delete me.entries[entryId];
							}

						});

						callback(null, entryIds);
					}, function(err) {
						callback(err);
					});
			};


			/**
			 * Export Glossary
			 */
			factory.export = function (mobileAppId) {
				var downloadUrl = '/v1/projects/' + mobileAppId + '/glossary/export';
				$window.location.href = downloadUrl;


				var eventData = {
					app_id: mobileAppId
				};
				EventTracker.track('Export Success', 'Glossary Export', eventData);
			};


			return factory;
		}
	]);
